import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { showModal } from "../../../../store/slices/modal";
import Alert from "@mui/material/Alert";

import useHttp from "../../../../hooks/useHttp";
import { CHANGE_ORDER_STATUS } from "../../../../utils/api-ends";
import store from "../../../../store";
import { deliveryImageValue } from "../../../../store/slices/deliveryImage";
import {
  canSeeDisputSectionValue,
  cancleDisputMessageValue,
  progrssBarStatusValue,
  canSeeCarrierProgressButtonValue,
} from "../../../../store/slices/Dispute";
import { canSeeGiveRatingAndReviewSectionValue } from "../../../../store/slices/order";
import LoaderImg from "../../../../assets/media/loader.gif";

const ProgressBar = ({ orderDetail }) => {
  const [buttonName, setButtonName] = useState("");
  const [progressStatus, setProgressStatus] = useState();
  const [canUploadFile, setCanUploadFile] = useState(false);
  const [canSeeDeliveryModal, setCanSeeDeliveryModal] = useState(false);
  const {
    sendRequests: orderProgress,
    error,
    isLoading: orderProgressLoading,
  } = useHttp();
  const userData = useSelector((state) => state.basicInfo.userDetails);
  const [errorMessage, setErrorMessage] = useState("");
  const [deliverdImage, setDeliverdImage] = useState(null);
  const dispatch = useDispatch();
  const disputeData = useSelector((state) => state.Dispute);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    orderDetail.status === 1
      ? setButtonName("Mark As Coming For Pick Up")
      : orderDetail.status === 2
      ? setButtonName("Mark As Picked Up")
      : orderDetail.status === 3
      ? setButtonName("Mark As Delivered")
      : orderDetail.status === 4
      ? setButtonName("Mark As Finished")
      : setButtonName("");
    setProgressStatus(orderDetail.status);
    store.dispatch(
      progrssBarStatusValue({ progrssBarStatus: orderDetail.status })
    );
  }, [orderDetail.status]);

  useEffect(() => {
    userData.user_type === "carrier" && progressStatus === 1
      ? store.dispatch(
          canSeeCarrierProgressButtonValue({
            canSeeCarrierProgressButton: true,
          })
        )
      : userData.user_type === "carrier" && progressStatus === 2
      ? store.dispatch(
          canSeeCarrierProgressButtonValue({
            canSeeCarrierProgressButton: true,
          })
        )
      : userData.user_type === "carrier" && progressStatus === 3
      ? store.dispatch(
          canSeeCarrierProgressButtonValue({
            canSeeCarrierProgressButton: true,
          })
        )
      : userData.user_type === "shipper" && progressStatus === 4
      ? store.dispatch(
          canSeeCarrierProgressButtonValue({
            canSeeCarrierProgressButton: true,
          })
        )
      : store.dispatch(
          canSeeCarrierProgressButtonValue({
            canSeeCarrierProgressButton: false,
          })
        );
    userData.user_type === "carrier" && progressStatus === 3
      ? setCanUploadFile(true)
      : setCanUploadFile(false);
    progressStatus === 4 || progressStatus === 5
      ? setCanSeeDeliveryModal(true)
      : setCanSeeDeliveryModal(false);

    progressStatus === 6 ? (
      store.dispatch(
        cancleDisputMessageValue({
          cancleDisputMessage: "This Order Is Cancled",
        })
      )
    ) : (
      <></>
    );
  }, [progressStatus, dispatch.progrssBarStatus]);

  const ProgressNext = (e) => {
    const buttonNameTag = e.target
      .closest(".pro-button")
      .getAttribute("buttonNameTag");
    const formData = new FormData();
    formData.append(
      "status",
      buttonNameTag === "Mark As Coming For Pick Up"
        ? 2
        : buttonNameTag === "Mark As Picked Up"
        ? 3
        : buttonNameTag === "Mark As Delivered"
        ? 4
        : buttonNameTag === "Mark As Finished"
        ? 5
        : 5
    );

    buttonNameTag === "Mark As Delivered" ? (
      formData.append("image", deliverdImage)
    ) : (
      <></>
    );


    const response = (data) => {
      buttonNameTag === "Mark As Coming For Pick Up"
        ? setButtonName("Mark As Picked Up")
        : buttonNameTag === "Mark As Picked Up"
        ? setButtonName("Mark As Delivered")
        : buttonNameTag === "Mark As Delivered"
        ? setButtonName("Mark as Finished")
        : setButtonName("Mark as Finished");

      buttonNameTag === "Mark As Coming For Pick Up"
        ? store.dispatch(progrssBarStatusValue({ progrssBarStatus: "2" }))
        : buttonNameTag === "Mark As Picked Up"
        ? store.dispatch(progrssBarStatusValue({ progrssBarStatus: "3" }))
        : buttonNameTag === "Mark As Delivered"
        ? store.dispatch(progrssBarStatusValue({ progrssBarStatus: "4" }))
        : buttonNameTag === "Mark As Finished"
        ? store.dispatch(progrssBarStatusValue({ progrssBarStatus: "5" }))
        : store.dispatch(progrssBarStatusValue({ progrssBarStatus: "5" }));

      buttonNameTag === "Mark As Coming For Pick Up"
        ? setProgressStatus(2)
        : buttonNameTag === "Mark As Picked Up"
        ? setProgressStatus(3)
        : buttonNameTag === "Mark As Delivered"
        ? setProgressStatus(4)
        : buttonNameTag === "Mark As Finished"
        ? setProgressStatus(5)
        : setProgressStatus(5);

      buttonNameTag === "Mark As Delivered" ? (
        store.dispatch(
          deliveryImageValue({
            deliveryImage: URL.createObjectURL(deliverdImage),
          })
        )
      ) : (
        <></>
      );

      buttonNameTag === "Mark As Finished" ? (
        store.dispatch(canSeeDisputSectionValue({ canSeeDisputSection: false }))
      ) : (
        <></>
      );

      buttonNameTag === "Mark As Finished" ? (
        store.dispatch(
          canSeeGiveRatingAndReviewSectionValue({
            canSeeGiveRatingAndReviewSection: true,
          })
        )
      ) : (
        <></>
      );

      setErrorMessage("");
    };

    orderProgress(
      {
        method: "PATCH",
        url: CHANGE_ORDER_STATUS(orderDetail.id),
        data: formData,
      },
      response
    );
  };

  const openDeliveryImageModal = (e) => {
    dispatch(
      showModal({
        modalName: "DeliveryImage",
        modalData: { orderImage: orderDetail.image },
      })
    );
  };

  const handleInputChange = (e) => {
    setDeliverdImage(e.target.files[0]);
  };

  useEffect(() => {
    if (error) {
      if (error.image) {
        setErrorMessage(error.image);
      }
      if(error.general){
        setErrorMessage(error.general)
      }
    }
  }, [error]);

  useEffect(() => {
    if (disputeData.progrssBarStatus === "3" && deliverdImage === null) {
      setIsButtonDisabled(true);
    } else {
      setIsButtonDisabled(false);
    }
  }, [disputeData.progrssBarStatus, deliverdImage]);

  console.log(disputeData.progrssBarStatus)

  return (
    <>
      <section id="order-progress-bar">
        <div className="container theme-section">
        <h1 className="section-tittle"> Offer Tracking Details </h1>
          {errorMessage && (
            <div className="auth-error withdraw-message-style mb-4">
              <Alert className="withdraw-alert-message" severity="info">
                {errorMessage}
              </Alert>
            </div>
          )}
          {disputeData.cancleDisputMessage && (
            <div className="auth-error withdraw-message-style mb-4">
              <Alert className="withdraw-alert-message" severity="info">
                {disputeData.cancleDisputMessage}
              </Alert>
            </div>
          )}

          <div
            className="progress-bar-length"
            completed={disputeData.progrssBarStatus}
          >
            <div className="progress-bar-box" progress="1">
              <div className="progress-bar-cercle">
                <i className="fa-solid fa-check-double"></i>
              </div>
              <span>Waiting for Picking Up</span>
            </div>

            <div className="completed-line" progress-line="1"></div>

            <div className="progress-bar-box" progress="2">
              <div className="progress-bar-cercle">
                <i className="fa-solid fa-check-double"></i>
              </div>
              <span>Coming for Picking Up</span>
            </div>

            <div className="completed-line" progress-line="2"></div>

            <div className="progress-bar-box" progress="3">
              <div className="progress-bar-cercle">
                <i className="fa-solid fa-check-double"></i>
              </div>
              <span>Picked Up</span>
            </div>

            <div className="completed-line" progress-line="3"></div>

            <div className="progress-bar-box" progress="4">
              <div className="progress-bar-cercle">
                <i className="fa-solid fa-check-double"></i>
              </div>
              <span>Delivery</span>
            </div>

            <div className="completed-line" progress-line="4"></div>

            <div className="progress-bar-box" progress="5">
              <div className="progress-bar-cercle">
                <i className="fa-solid fa-check-double"></i>
              </div>
              <span>Finished</span>
            </div>

            <div className="current-length-bg"></div>
          </div>

          {canUploadFile === true && (
            <div
              className="file-upload-for-delivery"
              image-uploaded={deliverdImage?.name ? "true" : "false"}
            >
              <input
                type="file"
                name="profile_picture"
                onChange={handleInputChange}
              />
              <p> Upload Your File By Clicking Here </p>
              {deliverdImage?.name && (
                <Alert severity="success">File is Successfully Uploaded</Alert>
              )}
            </div>
          )}

          <div className="multiple-btn modal-button progress-button-list-style">
            {disputeData.canSeeCarrierProgressButton === true && (
              <button
                className="m-0 pro-button"
                buttonNameTag={buttonName}
                onClick={ProgressNext}
                disabled={isButtonDisabled}
              >
                {buttonName}
                {orderProgressLoading && (
                  <img src={LoaderImg} style={{ width: "24px" }} alt="" />
                )}
              </button>
            )}
            {canSeeDeliveryModal === true && (
              <button
                className="m-0 pro-button"
                onClick={openDeliveryImageModal}
              >
                See Proof of Delivery Image
              </button>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default ProgressBar;
